import BlogCard from "../page_components/blog/BlogCard";
import Spinner from "../components/Spinner";
import useFetch from "../hooks/useFetch";

const Blogs = () => {
    const {
		data: blogs,
		isLoading,
		errorMessage,
	} = useFetch("http://localhost:8000/blogs");

	return (
		<>
			{isLoading && <Spinner />}
			{errorMessage && <div>{errorMessage}</div>}
			{blogs && <BlogCard blogs={blogs} title="All Blogs" />}
		</>
	);
}
 
export default Blogs;